export class OutingIterationDetails{
    public id: string;
    public name: string;
    public description: string;
    public cost: string;
    public notes: string;
    public outingIterationId: string;  
    public lastEditedBy: string; 
}